import React, { ReactNode } from 'react';
import useUserState, { UserState } from '../hooks/user/userState';

type Props = {
  children: ReactNode;
};

export const UserStateContext = React.createContext<UserState | undefined>(undefined);

/**
 * Custom hook to safely access UserStateContext
 * Throws an error if used outside of UserStateProvider
 */
export const useUserStateContext = (): UserState => {
  const context = React.useContext(UserStateContext);
  if (!context) {
    throw new Error('useUserStateContext must be used within UserStateProvider');
  }
  return context;
};

const UserStateProvider = ({ children }: Props) => {
  const userState = useUserState();

  return (
    <UserStateContext.Provider value={userState}>
      {children}
    </UserStateContext.Provider>
  );
};

export default UserStateProvider;
